import CoatingBreakdown from './CoatingBreakdown.vue';
import CoverageLevels from './CoverageLevels.vue';
import DegreeOfRusting from './DegreeOfRusting.vue';
import UnitField from './UnitField.vue';
import EquipmentTag from './EquipmentTag.vue';

export default { CoatingBreakdown, CoverageLevels, DegreeOfRusting, UnitField, EquipmentTag };
